/**
 * @generated SignedSource<<cdbb621ac4ef7944807ab770c230da08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateKeyFeaturesSectionContentfulRelayFragment$data = {
  readonly keyFeaturesCollection: {
    readonly items: ReadonlyArray<{
      readonly featureNameExternal: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "templateKeyFeaturesSectionContentfulRelayFragment";
};
export type templateKeyFeaturesSectionContentfulRelayFragment$key = {
  readonly " $data"?: templateKeyFeaturesSectionContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateKeyFeaturesSectionContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateKeyFeaturesSectionContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductTemplateKeyFeaturesCollection",
      "kind": "LinkedField",
      "name": "keyFeaturesCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyFeature",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "featureNameExternal",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductTemplate",
  "abstractKey": null
};

(node as any).hash = "ea58d8a7472ddea992087c51d1db8a28";

export default node;
